import { applyMiddleware, legacy_createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import environment from './config.json'
import { initiateLogin, verifyLogin } from './redux/Login/loginActions'
import reducers from './redux/reducers'
import { hideLoader, initiateCommon } from './redux/Common/commonActions'

const middleware = [thunk]
const preloadedState = sessionStorage.getItem("store")
  ? JSON.parse(sessionStorage.getItem("store"))
  : {
      login: {
        user: {
          login: false,
        },
        alert: null,
        auth: null,
      },
      common: {
        url: null,
        loading: false,
      },
    };

const store = legacy_createStore(
  reducers,
  preloadedState,
  composeWithDevTools(applyMiddleware(...middleware))
);

// store.dispatch(initiateLogin(preloadedState.login));
// store.dispatch(initiateCommon(preloadedState.common));
// store.dispatch(hideLoader());
if (preloadedState.login.auth !== null && preloadedState.login.user.login) {
  console.log("Verifying Token...");
  setInterval(() => store.dispatch(verifyLogin()), 660000);
}

export default store
